import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useState } from "react";
import EmptyTextModal from "./Dashboard/EmptyTextModal";
import { getAppVersions } from "../services/cms";
import { Link } from "react-router-dom";

export default function Footer() {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 769px)",
  });

  const tmpTheme = process.env.REACT_APP_TEMP_THEME;
  const [appLink, setAppLink] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedText, setSelectedText] = useState("");
  function Openchanger(stat) {
    setModalIsOpen(stat);
  }
  const TextForAppMyket = (
    <>
      برای دانلود اپلیکیشن طلایی شو کافیه پس از ورود به مایکت اپلیکیشن طلایی شو
      جستجو، دانلود و نصب نمایید
    </>
  );
  const TextForAppBazaar = (
    <>
      برای دانلود اپلیکیشن طلایی شو کافیه پس از ورود به بازار اپلیکیشن طلایی شو
      جستجو، دانلود و نصب نمایید
    </>
  );
  const TextForAppPlay = (
    <>
      برای دانلود اپلیکیشن طلایی شو کافیه پس از ورود به گوگل پلی اپلیکیشن طلایی
      شو جستجو، دانلود و نصب نمایید
    </>
  );
  useEffect(() => {
    getAppVersions().then((data) => {
      setAppLink(data?.data?.data?.application_file);
    });
  }, []);
  return (
    <>
      {isDesktopOrLaptop ? (
        <footer className="footer-css">
          <div className="row">
            {tmpTheme != 1 ? (
              <div className="col-4 hfuhahfuha367643 pr-0">
                <div>
                  <div className="d-flex">
                    <div className="cir">
                      <img
                        src="images/footerLogo-last.svg"
                        className="logo"
                        alt=""
                      />
                    </div>
                  </div>

                  <div className="olokisdhfont92763 pb-4">
                    پاسخگوی شما هستیم: ۱۹ ۹۲۴ ۹۱۶ ۰۲۱{" "}
                  </div>
                  <div>
                    <a
                      className="ms-2"
                      href={"https://www.aparat.com/talaeshow"}
                    >
                      <img src="/images/aparatLogo.svg" />{" "}
                    </a>
                    <a
                      className="ms-2"
                      href={
                        "https://instagram.com/talae.show?igshid=NGExMmI2YTkyZg=="
                      }
                    >
                      <img src="/images/InstagramLogo.svg" />{" "}
                    </a>
                    <a
                      className="ms-2"
                      href={"https://www.linkedin.com/company/talaeshow/"}
                    >
                      <img src="/images/LinkedinLogo.svg" />{" "}
                    </a>
                    <a className="ms-2" href={"https://t.me/talaeshow"}>
                      <img src="/images/TelegramLogo.svg" />{" "}
                    </a>
                    <a
                      className="ms-2"
                      href={
                        "https://twitter.com/talaeshow?t=pco7XGZ_7atlZFB1f4peQA&s=09"
                      }
                    >
                      <img src="/images/TwitterLogo.svg" />{" "}
                    </a>
                  </div>
                </div>{" "}
              </div>
            ) : (
              <div className="col-12 hfuhahfuha367643 pr-0 txt-center-temp">
                <div>
                  <div
                    className={
                      tmpTheme != 1
                        ? "d-flex"
                        : "d-flex center-logo-desktop-theme"
                    }
                  >
                    <div className="cir">
                      <img
                        src="images/footerLogo-last.svg"
                        className="logo"
                        alt=""
                      />
                    </div>
                  </div>

                  <div
                    className={
                      tmpTheme != 1
                        ? "olokisdhfont92763 text-center pb-4"
                        : "olokisdhfont92763 pb-4 center-desktop-theme"
                    }
                  >
                    پاسخگوی شما هستیم: ۱۹ ۹۲۴ ۹۱۶ ۰۲۱{" "}
                  </div>
                  <div>
                    <a
                      className="ms-2"
                      href={"https://www.aparat.com/talaeshow"}
                    >
                      <img src="/images/aparatLogo.svg" />{" "}
                    </a>
                    <a
                      className="ms-2"
                      href={
                        "https://instagram.com/talae.show?igshid=NGExMmI2YTkyZg=="
                      }
                    >
                      <img src="/images/InstagramLogo.svg" />{" "}
                    </a>
                    <a
                      className="ms-2"
                      href={"https://www.linkedin.com/company/talaeshow/"}
                    >
                      <img src="/images/LinkedinLogo.svg" />{" "}
                    </a>
                    <a className="ms-2" href={"https://t.me/talaeshow"}>
                      <img src="/images/TelegramLogo.svg" />{" "}
                    </a>
                    <a
                      className="ms-2"
                      href={
                        "https://twitter.com/talaeshow?t=pco7XGZ_7atlZFB1f4peQA&s=09"
                      }
                    >
                      <img src="/images/TwitterLogo.svg" />{" "}
                    </a>
                  </div>
                </div>{" "}
              </div>
            )}
            <div className="col-4 mt-5">
              {tmpTheme != 1 && (
                <div className="jgfdyddtydtytrsw">
                  امکانات بیشتر با دانلود اپلیکیشن
                </div>
              )}
              {tmpTheme != 1 && (
                <>
                  <div className="d-flex pb-3 fwrfwrw24235css justify-content-center">
                    <a
                      // onClick={() => {
                      //   setSelectedText(TextForAppBazaar);
                      //   setModalIsOpen(true);
                      // }}
                      href="https://play.google.com/store/apps/details?id=com.talaeesho.android"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/images/bazar-last.svg" alt="" />
                    </a>
                    <a href={appLink} target="_blank" rel="noopener noreferrer">
                      <img
                        src="/images/android-last.svg"
                        className="pe-2"
                        alt=""
                      />
                    </a>
                  </div>
                  <div className="d-flex justify-content-center">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.talaeesho.android"
                      target="_blank"
                    >
                      <img src="/images/googleplay-last.svg" alt="" />
                    </a>

                    <a
                      // onClick={() => {
                      //   setSelectedText(TextForAppMyket);
                      //   setModalIsOpen(true);
                      // }}
                      href="https://myket.ir/app/com.talaeesho.android"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="/images/myket-last.svg"
                        className="pe-2"
                        alt=""
                      />
                    </a>
                  </div>
                </>
              )}
              {tmpTheme != 1 && (
                <div className={"center-help-footer"}>
                  <Link to={"/help"}>راهنمای سایت</Link>
                </div>
              )}
            </div>

            <div className="col-4 ">
              <div
                className={`d-flex justify-content-end ${tmpTheme == 1
                    ? "lower-temp-desktop-pad"
                    : "ksihfy6ete justify-the-footer-icons"
                  }`}
              >
                <div>
                  <a
                    referrerpolicy="origin"
                    target="_blank"
                    href="https://trustseal.enamad.ir/?id=278507&Code=zub8M62KicbUtNkIPuj3"
                  >
                    <img
                      referrerpolicy="origin"
                      src="https://trustseal.enamad.ir/logo.aspx?id=278507&Code=zub8M62KicbUtNkIPuj3"
                      alt=""
                      style={{ cursor: "pointer" }}
                      code="zub8M62KicbUtNkIPuj3"
                    />
                  </a>
                </div>
                <div>
                  <a
                    href="https://qr.mojavez.ir/track/13298921"
                    target="_blank"
                  >
                    <img src={"/images/mojavez.png"} width={100} />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center footer-color text-white">
            تهران، اطلس مال طبقه G4 شماره ۴۰۳۸
          </div>
        </footer>
      ) : (
        <footer className="footer-css">
          <div className="col-12  pr-0 text-center">
            <div>
              <div
                className={`d-flex justify_content_center ${tmpTheme == 1 ? "center-logo-temp" : ""
                  }`}
              >
                <div className="cir">
                  <img
                    src="/images/logo-footer-mobile.svg"
                    className="logo"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row pt-5">
            <div
              className={tmpTheme == 1 ? "col-12 text-center-temp" : "col-5"}
            >
              <div className="dl-apps">
                دانلود اپلیکیشن
                <Link className={"footer-links"} to={"/help"}>
                  راهنمای سایت
                </Link>
                <Link className={"footer-links"} to={"/blog"}>
                  وبلاگ
                </Link>
              </div>
            </div>
            {tmpTheme != 1 && (
              <>
                <div className="col-7">
                  <div className="row footer-mt">
                    <div className="col-6">
                      <a
                        className="mobile-namad-logo-footer"
                        referrerpolicy="origin"
                        target="_blank"
                        href="https://trustseal.enamad.ir/?id=278507&Code=zub8M62KicbUtNkIPuj3"
                      >
                        <img
                          referrerpolicy="origin"
                          src="https://trustseal.enamad.ir/logo.aspx?id=278507&Code=zub8M62KicbUtNkIPuj3"
                          alt=""
                          style={{ cursor: "pointer" }}
                          code="zub8M62KicbUtNkIPuj3"
                        />
                      </a>
                    </div>
                    <div className="col-6">
                      <a
                        className="mobile-namad-logo-footer"
                        href="https://qr.mojavez.ir/track/13298921"
                        target="_blank"
                      >
                        <img src={"/images/mojavez.png"} width={100} />
                      </a>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 m-height-footer-mobile">
                      <a
                        // onClick={() => {
                        //   setSelectedText(TextForAppBazaar);
                        //   setModalIsOpen(true);
                        // }}
                        href="https://play.google.com/store/apps/details?id=com.talaeesho.android"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/images/bazar-last.svg"
                          className="imushushd55323"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="col-6 m-height-footer-mobile">
                      <a href={appLink}>
                        <img
                          src="/images/android-last.svg"
                          className="pe-2 imushushd55323"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="clearfix"></div>

                    <div className="col-6 m-height-footer-mobile">
                      <a
                        href="https://play.google.com/store/apps/details?id=com.talaeesho.android"
                        target="_blank"
                      >
                        <img
                          src="/images/googleplay-last.svg"
                          className="imushushd55323"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="col-6 m-height-footer-mobile">
                      <a
                        // onClick={() => {
                        //   setSelectedText(TextForAppMyket);
                        //   setModalIsOpen(true);
                        // }}
                        href="https://myket.ir/app/com.talaeesho.android"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/images/myket-last.svg"
                          className="pe-2 imushushd55323"
                          alt=""
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="row">
            <div className="col-1"></div>
            <div className="col-2 text-center">
              <a
                href={
                  "https://instagram.com/talae.show?igshid=NGExMmI2YTkyZg=="
                }
              >
                <img
                  src="/images/InstagramLogo.svg"
                  className="iconsize2212"
                  alt=""
                />
              </a>
            </div>

            <div className="col-2 text-center">
              <a href={"https://t.me/talaeshow"}>
                <img
                  src="/images/TelegramLogo.svg"
                  className="iconsize2212"
                  alt=""
                />
              </a>
            </div>
            <div className="col-2 text-center">
              <a
                href={"https://www.linkedin.com/company/talaeshow/"}
                className="d-flex"
              >
                <img
                  src="/images/LinkedinLogo.svg"
                  className="iconsize2212"
                  alt=""
                />
              </a>
            </div>
            <div className="col-2 text-center">
              <a
                href={
                  "https://twitter.com/talaeshow?t=pco7XGZ_7atlZFB1f4peQA&s=09"
                }
              >
                <img
                  src="/images/TwitterLogo.svg"
                  className="iconsize2212"
                  alt=""
                />
              </a>
            </div>
            <div className="col-2 text-center">
              <a href={"https://www.aparat.com/talaeshow"}>
                <img
                  src="/images/aparatLogo.svg"
                  className="iconsize2212"
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="text-center pt-3 text-large text-white">
            تهران، اطلس مال طبقه G4 شماره ۴۰۳۸
          </div>

          <div
            className={`mobile-enmad mt-3 ${tmpTheme == 1 ? "center-tmp-logo-enamad" : ""
              }`}
          >
            <div className="text-white text-medium text-right mx-auto">
              پاسخگوی شما هستیم: ۹۱۶۹۲۴۱۹-۰۲۱
            </div>
          </div>
        </footer>
      )}
      <EmptyTextModal
        modalIsOpen={modalIsOpen}
        Openchanger={Openchanger}
        text={selectedText}
      />
    </>
  );
}
